module.exports = __webpack_public_path__ + "static/the-art-of-deception-1f08bc71506fe12a1e054d04088e44b3.jpg";